import { component } from 'picoapp';

export default component((node, ctx) => {

    class VideoPlayer extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.lunch();
            };
            new IntersectionObserver(handleIntersection.bind(this)).observe(this);
        }

        lunch(){
            this.video = this.querySelector('video');
            if (!this.video) return;

            this.video.play();
        }
    }

    if (!customElements.get('video-player')) {
        customElements.define('video-player', VideoPlayer);
    }

    class VimeoPlayer extends VideoPlayer {
        constructor() {
            super();
        }

        lunch(){
            this.iframe = this.querySelector('iframe');
            if (!this.iframe) return;

            this.player = new Vimeo.Player(this.iframe);
            this.player.play();
        }
    }

    if (!customElements.get('vimeo-player')) {
        customElements.define('vimeo-player', VimeoPlayer);
    }
});
